interface TaskTimerProps{
  trackedTimeInSec:number
}

interface timeFormate{
  hours:number,
  minutes:number,
  seconds:number
}

const TaskTimer = ({trackedTimeInSec}:TaskTimerProps) => {

  const formatTimeWithSecond = (timeInSeconds: number = 0):timeFormate=>{
    const hours: number = Math.floor(timeInSeconds / 3600);
    const minutes: number = Math.floor((timeInSeconds % 3600) / 60);
    const seconds: number = timeInSeconds % 60;
    return {hours,minutes,seconds}
  }

  const formatedTimeString = (timeInSeconds: number): string => {
    const {hours,minutes,seconds} = formatTimeWithSecond(timeInSeconds)
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div>
      <div>
        {formatedTimeString(trackedTimeInSec || 0)}
      </div>
    </div>
  );
};

export default TaskTimer;
